const getResourceListPreferences = (data) => {
  return typeof data === "object" && !!data && "version" in data && "filters" in data ? data : void 0;
};

export { getResourceListPreferences };
//# sourceMappingURL=getResourceListPreferences.js.map
